/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SalesRepresentativeService = {
  async getByName(name) {
    const requestScreenData = {
      url: "api/SalesRepresentative",
      top: "1",
      filter: `FirstName eq '${name}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByCode(code, params) {
    const requestScreenData = {
      url: "api/SalesRepresentative",
      top: "1",
      filter: `Code eq '${code}'`,
    };
    if (params) {
      if (params.select) {
        requestScreenData.select = params.select;
      }
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async getUserDefaultSalesRepresentative(params) {
    var url = "api/UserDefaultSalesRepresentative";
    const requestScreenData = {
      url: "api/UserDefaultSalesRepresentative",
      // select: ["SalesRepresentativeFullName"],
    };
    if (params) {
      if (params.select) {
        requestScreenData.select = params.select;
      }
    }
    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
};

export { SalesRepresentativeService };
